<form [formGroup]="avanceForm">
    <h2 mat-dialog-title>Reportar avance tarea</h2>
    <mat-dialog-content>
        <mat-form-field class="full-width">
            <mat-label>Porcentaje avance</mat-label>
            <mat-select formControlName="porcentaje">
                @for (porcentaje of porcentajesAvance; track $index) {
                <mat-option value={{porcentaje}}>{{porcentaje}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Comentario</mat-label>
            <textarea matInput formControlName="comentario"></textarea>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close cdkFocusInitial>Cancelar</button>
        <button type="submit" mat-flat-button (click)="close()" [disabled]="!avanceForm.valid || fetchingAvanceTarea">
            <div class="btn-login-content">
                @if (fetchingAvanceTarea) {
                <mat-spinner diameter="20" color="warn"></mat-spinner>
                }@else{
                <p>Aceptar</p>
                }
            </div>
        </button>
    </mat-dialog-actions>
</form>